module.exports = __webpack_public_path__ + "static/media/q_nav_5_not_selected.219f18c6.svg";